var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSliderControl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_605_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.80588 29.4996C7.12567 29.82 7.55999 30 8.01278 30C8.46555 30 8.89961 29.82 9.21969 29.4996L22.4996 16.2067C22.82 15.8867 23 15.4526 23 14.9998C23 14.547 22.82 14.113 22.4996 13.7929L9.21969 0.500037C8.78834 0.0686862 8.16007 -0.0996832 7.57109 0.0582777C6.98207 0.215941 6.5219 0.676146 6.36418 1.26518C6.20622 1.8542 6.37459 2.48245 6.80594 2.91379L18.8796 14.9996L6.80594 27.0733C6.48168 27.3937 6.29903 27.8307 6.29903 28.2867C6.29903 28.7425 6.48168 29.1795 6.80593 29.4999L6.80588 29.4996Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_605_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(30 30) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderControl);
export default __webpack_public_path__ + "static/media/sliderControl.e60ebb29bb1949402bf019a2a91e7094.svg";
export { ForwardRef as ReactComponent };